import React from "react";
import { useStore } from "utils/useStore";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import { LLMClassifierBuilderStore } from "components/Classifiers/LLMClassifiers/Stores/LLMClassifierBuilderStore";
import { LLMExecutionResultInformation } from "../LLMExecutionResultInformation";
import { LLMReasoning } from "../LLMReasoning";
import { TestedConversationDetails } from "../TestedConversationDetails";
import { ResultActions } from "./ResultActions";

interface SuccessfulResultProps {
    result: TestLLMClassifierAgreementResult;
    number: number;
}

export function SuccessfulResult({ result, number }: SuccessfulResultProps) {
    const store = useStore(LLMClassifierBuilderStore);

    const resultFromStep =
        store.classifier.implementation.isLogicChain() && result.decisionStepId
            ? store.classifier.implementation.logicChainBuilder.getStepbyId(
                  result.decisionStepId,
              )
            : undefined;

    return (
        <React.Fragment>
            <TestedConversationDetails
                conversation={result.conversation}
                number={number}
                labels={{
                    human: result.conversation.labeled,
                    model: result.decision,
                }}
                wouldExecuteUnderConditions={result.wouldExecuteUnderConditions}
                source={result.conversation.isSynthetic ? "synthetic" : "human"}
            />
            <LLMReasoning
                reasoning={result.reasoning}
                fromStep={resultFromStep?.name}
            />
            {result.executionResult && (
                <LLMExecutionResultInformation
                    executionResult={result.executionResult}
                >
                    <LLMExecutionResultInformation.StepRunInformation />
                    <LLMExecutionResultInformation.ClassifierResultsToWrite />
                    <LLMExecutionResultInformation.ExtendedMetadataToWrite />
                    <LLMExecutionResultInformation.StepVariables />
                </LLMExecutionResultInformation>
            )}
            <ResultActions result={result} />
        </React.Fragment>
    );
}
